const getEditedCategory = edits => edits.category;
const getEditedIcon = edits => edits.icon;
const getEnvironment = () => (import.meta.env.DEV ? 'develop' : 'prod');

export { getEditedCategory, getEditedIcon, getEnvironment };
